import { createFileRoute } from "@tanstack/react-router";

const LAST_UPDATED = "July 12, 2026";

export const Route = createFileRoute("/legal/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — European Wig Luxury" },
      { name: "description", content: "How European Wig Luxury collects, uses, and protects your personal information." },
      { property: "og:title", content: "Privacy Policy — European Wig Luxury" },
      { property: "og:description", content: "How European Wig Luxury collects, uses, and protects your personal information." },
      { property: "og:url", content: "https://europeanwigluxury.com/legal/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://europeanwigluxury.com/legal/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <article className="container-luxe max-w-3xl py-16 md:py-24">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-3 font-display text-4xl md:text-5xl">Privacy Policy</h1>
      <p className="mt-4 text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>

      <div className="prose-luxe mt-10 space-y-8 text-base leading-relaxed text-foreground/85">
        <section>
          <h2 className="font-display text-2xl">1. What we collect</h2>
          <p className="mt-3">When you shop or book with European Wig Luxury we collect the information you give us — your name, shipping and billing address, email, phone number, and payment details — along with basic device and browsing information (IP address, browser type, pages viewed) collected automatically by our site.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">2. How we use it</h2>
          <p className="mt-3">We use your information to process orders, arrange discreet shipping, provide consultations, respond to support requests, prevent fraud, and — with your permission — send you updates about new pieces and care.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">3. Who we share it with</h2>
          <p className="mt-3">We share information only with the providers we need to run our business: our e-commerce platform, payment processor, shipping carriers, and — if you request one — the issuer of your cranial prosthesis invoice. We never sell your personal data.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">4. Your choices</h2>
          <p className="mt-3">You can request a copy of your data, ask us to correct or delete it, or opt out of marketing at any time by emailing <a className="text-bronze underline" href="mailto:care@europeanwigluxury.com">care@europeanwigluxury.com</a>. We honor GDPR and CCPA rights for eligible residents.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">5. Cookies</h2>
          <p className="mt-3">We use essential cookies to keep your cart and session working, and analytics cookies to understand how the site is used. You can disable non-essential cookies in your browser settings.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">6. Contact</h2>
          <p className="mt-3">Questions about this policy? Reach us at <a className="text-bronze underline" href="mailto:care@europeanwigluxury.com">care@europeanwigluxury.com</a>.</p>
        </section>
      </div>
    </article>
  );
}
